// =============================================================================
// Lumen Viewer — MSAL configuration
// =============================================================================

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const redirect = import.meta.env.VITE_ENTRA_REDIRECT_URI;
const scope    = import.meta.env.VITE_ENTRA_SCOPES;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirect,
    postLogoutRedirectUri: redirect,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // NEVER persist tokens to localStorage
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    // Keep MSAL quiet in prod — we use our own logger.
    loggerOptions: { piiLoggingEnabled: false },
  },
};

export const loginRequest = {
  scopes: scope ? scope.split(/\s+/).filter(Boolean) : ['openid', 'profile', 'email'],
};
